import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function BeforeAfterSection() {
  const beforeItems = ['Horas perdidas en redes sociales', 'Tiempo muerto sin aprovechar', 'Falta de nuevas ideas', 'Estancamiento mental', 'Sensación de no avanzar'];
  const afterItems = ['Aprendizaje constante', 'Ideas nuevas cada día', 'Mayor claridad mental', 'Mejor mentalidad para avanzar', 'Sensación real de progreso personal'];
  return <section className="py-10 px-4 bg-[#0A0A0A]" data-id="element-18">
      <div className="max-w-5xl mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-20">
          <h2 className="text-3xl md:text-5xl font-black text-center mb-8 uppercase tracking-tight text-white" data-id="element-21">
            Antes vs Después
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-22">
            {/* Before Card */}
            <div className="bg-gray-900 rounded-2xl p-6 md:p-8 border-t-4 border-red-500 shadow-xl" data-id="element-23">
              <div className="flex items-center justify-center mb-6" data-id="element-24">
                <div className="bg-red-500/10 text-red-500 font-black text-lg px-4 py-1.5 rounded-full uppercase border border-red-500/20" data-id="element-25">
                  ❌ Antes de la Biblioteca
                </div>
              </div>

              <ul className="space-y-4" data-id="element-26">
                {beforeItems.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-27">
                    <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-28" />
                    <span className="text-base md:text-lg font-bold text-gray-300" data-id="element-29">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* After Card */}
            <div className="bg-gray-900 rounded-2xl p-6 md:p-8 border-t-4 border-[#8FF650] shadow-2xl transform md:scale-105" data-id="element-30">
              <div className="flex items-center justify-center mb-6" data-id="element-31">
                <div className="bg-[#8FF650] text-black font-black text-lg px-4 py-1.5 rounded-full uppercase" data-id="element-32">
                  ✅ Después de la Biblioteca
                </div>
              </div>

              <ul className="space-y-4" data-id="element-33">
                {afterItems.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-34">
                    <CheckCircle2 className="w-6 h-6 text-[#8FF650] flex-shrink-0 mt-0.5" data-id="element-35" />
                    <span className="text-base md:text-lg font-bold text-white" data-id="element-36">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}